import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import { sanitizer } from '../../common/sanitizer';

const StepHeader = ({
  content,
  classExt,
  explainComponent = null,
  useHeadlineExplain = false,
  headline = null,
}) => {
  if (useHeadlineExplain && headline && explainComponent) {
    // Render custom headline with explain text
    return (
      <div className={`ltFormQuestionHeader ${classExt}`}>
        <div className="ltFormHeadlineContainer">
          <h1 className="ltFormQuestionHeadline">
            {Parser().parse(sanitizer(headline))}
            {explainComponent}
          </h1>
        </div>
      </div>
    );
  }

  // Default behavior
  return (
    <div
      className={`ltFormQuestionHeader ${classExt}`}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

StepHeader.propTypes = {
  content: PropTypes.string,
  classExt: PropTypes.string,
  explainComponent: PropTypes.element,
  useHeadlineExplain: PropTypes.bool,
  headline: PropTypes.string,
};

export default StepHeader;
